import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    strength: PropTypes.number,
    dict: PropTypes.object
};

const defaultProps = {
    strength: null
};

function StrengthMeter(props) {
    var meterElements = [];
    let strengthClass = '';
    let strengthLabel;
    let indicator;

    if (props.strength !== null) {
        for (var i = 0; i < props.strength + 1; i++) {
            meterElements.push(<span key={i} className="mfa-strength-meter-segment" />);
        }
        var strengthWord = props.dict[props.strength];

        strengthClass = 'is-' + strengthWord.toLocaleLowerCase();

        strengthLabel = (
            <p>
                Strength: <span className="asc-font-bold">{strengthWord}</span>
            </p>
        );
        indicator = (
            <div className={'mfa-strength-meter-indicator ' + strengthClass}>{meterElements}</div>
        );
    }

    return (
        <div className="mfa-strength-meter asc-form-group">
            {strengthLabel}
            <p className="asc-form-subtext">
                Please consider using a password manager to generate and store a unique password.
                Don’t share it or write it down.{' '}
            </p>
            {indicator}
        </div>
    );
}
StrengthMeter.propTypes = propTypes;
StrengthMeter.defaultProps = defaultProps;
export default StrengthMeter;
